import React from "react";

const Switch = ({ isActive, onStatusChange, itemId }) => {

  const toggleStatus = () => {
    const newStatus = !isActive;
    onStatusChange(itemId, newStatus);
  };

  return (
    <label
      htmlFor={`${itemId}`}
      className="flex cursor-pointer select-none items-center"
      onClick={toggleStatus}
    >
      <div className="relative">
        <input
          type="checkbox"
          id={`toggle-${itemId}`}
          className="sr-only"
          checked={isActive}
          readOnly
        />
        <div className="block h-8 w-14 rounded-full bg-[#e5e7eb]"></div>
        <div
          className={`absolute left-1 top-1 h-6 w-6 rounded-full bg-white transition ${
            isActive && "!right-1 !translate-x-full !bg-blue-500"
          }`}
        ></div>
      </div>
      <p
        className={`ml-2 inline-flex rounded-full py-1 px-3 text-sm font-medium ${
          isActive ? "bg-green-400 text-green-700" : "bg-red-400 text-red-700"
        }`}
      >
        {isActive ? "Activated" : "Deactivated"}
      </p>
    </label>
  );
};

export default Switch;
